export const COMMENT_POST_REQUEST = "COMMENT_POST_REQUEST";
export const COMMENT_POST_SUCCESS = "COMMENT_POST_SUCCESS";
export const COMMENT_POST_FAILURE = "COMMENT_POST_FAILURE";

export const COMMENT_GET_REQUEST = "COMMENT_GET_REQUEST";
export const COMMENT_GET_SUCCESS = "COMMENT_GET_SUCCESS";
export const COMMENT_GET_FAILURE = "COMMENT_GET_FAILURE";
